export default "__VITE_ASSET__DOhN0rDL__"